import $ from 'jquery';

class AddThis {
  constructor() {
    this.shareButtons = $('.js-addthis');

    if (!this.shareButtons.length) {
      return;
    }

    $(window).on('load', () => {
      this.init();
    });
  }

  init() {
    this.script = document.createElement('script');
    this.configScript = document.createElement('script');
    const code = 'var addthis_config = {"data_track_addressbar": false}';

    this.configScript.appendChild(document.createTextNode(code));
    document.body.appendChild(this.configScript);

    this.script.setAttribute(
      'src',
      '//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-50c78ca4247a6c72',
    );

    document.body.appendChild(this.script);
  }
}

export default new AddThis();



// WEBPACK FOOTER //
// ./src/scripts/modules/addthis.js